module.exports = __webpack_public_path__ + "img/soccerboard23.85f6b419.jpg";